import {AlertComponent} from './alert/alert.component';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {DataTableModule} from "angular2-datatable";
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {routing, appRoutingProviders} from './app.routes';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {Ng2SmartTableModule} from 'ng2-smart-table';


import {AppComponent} from './app.component';
import {AppConfig} from './app.config';
import {AuthGuard} from './auth.guard';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {DoctorComponent} from './components/doctor/doctor.component';
import {DoctorsComponent} from './components/doctors/doctors.component';
import {HeaderComponent} from './components/header/header.component';
import {HospitalsComponent} from './components/hospitals/hospitals.component';
import {InvoicesComponent} from './components/invoices/invoices.component';
import {LoginComponent} from './components/login/login.component';
import {NavigationComponent} from './components/navigation/navigation.component';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {RegisterComponent} from './components/register/register.component';
import {ReportsComponent} from './components/reports/reports.component';
import {UsersComponent} from './components/users/users.component';
import {AuthenticationService} from './services/authentication.service';
import {GlobalEventsManager} from './services/gobal-events-manager';
import {UserService} from './services/user.service';
import {PaymentsComponent} from './components/payments/payments.component';
import {HospitalComponent} from './components/hospital/hospital.component';
import {HospitalsService} from './services/hospitals.service';
import {DoctorsService} from "./services/doctors.service";
import {HospitalBranchesService} from "./services/hospital-branches.service";


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    NavigationComponent,
    NotFoundComponent,
    DashboardComponent,
    ReportsComponent,
    InvoicesComponent,
    AlertComponent,
    HeaderComponent,
    UsersComponent,
    DoctorsComponent,
    HospitalsComponent,
    DoctorComponent,
    PaymentsComponent,
    HospitalComponent
  ],
  imports: [
    BrowserModule,
    routing,
    FormsModule,
    HttpModule,
    Ng2SmartTableModule,
    SimpleNotificationsModule,
    DataTableModule,
    NgbModule.forRoot()
  ],
  providers: [appRoutingProviders,
    AuthenticationService,
    AppConfig,
    UserService,
    HospitalsService,
    HospitalBranchesService,
    DoctorsService,
    AuthGuard,
    GlobalEventsManager
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts